import { useEffect } from 'react';

import {
  clearPageWatchRefs,
  setPageWatchRefs,
} from '@/services/applications/applicationWatchSet';

type WatchableRow = {
  id: string;
  positionId: string;
};

/**
 * Registers visible table rows into the application Watch Set (Livello B).
 * Call from list pages with the current page slice only.
 */
export function useApplicationWatchSetRegistration(
  rows: readonly WatchableRow[],
  enabled = true,
): void {
  useEffect(() => {
    if (!enabled) {
      clearPageWatchRefs();
      return;
    }

    setPageWatchRefs(
      rows.map((row) => ({
        applicationId: row.id,
        positionId: row.positionId,
      })),
    );

    return () => clearPageWatchRefs();
  }, [rows, enabled]);
}
